export const GA_MEASUREMENT_ID = "G-L3P6S9933K";

export const trackPageView = (path: string) => {
  if (!window.gtag) return;
  window.gtag("config", GA_MEASUREMENT_ID, { page_path: path });
};

export const trackEvent = (
  action: string,
  category: string,
  label?: string,
  value?: number
) => {
  if (!window.gtag) return;
  window.gtag("event", action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};
